// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/pricing.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddCompetitorPriceRequest, AddCompetitorPriceResponse, AddPriceListRuleRequest, ApplyPromocodeRequest, ApplyPromocodeResponse, AssignPromocodeRequest, AssignPromocodeResponse, BulkCalculatePricesRequest, BulkCalculatePricesResponse, CalculatePriceRequest, CalculatePriceResponse, CreateDiscountRequest, CreatePriceListRequest, CreatePromocodeRequest, DeleteDiscountRequest, DeletePriceListRequest, DeletePromocodeRequest, Discount, GeneratePriceSuggestionsRequest, GeneratePriceSuggestionsResponse, GetDiscountRequest, GetPriceAnalyticsRequest, GetPriceAnalyticsResponse, GetPriceAtDateRequest, GetPriceAtDateResponse, GetPriceHistoryRequest, GetPriceHistoryResponse, GetPriceListRequest, GetProductCompetitorPricesRequest, GetProductCompetitorPricesResponse, GetProductDiscountsRequest, GetProductDiscountsResponse, GetProductPOHistoryRequest, GetProductPOHistoryResponse, GetProductPriceSuggestionsRequest, GetProductPriceSuggestionsResponse, GetPromocodeRequest, ImportCompetitorFeedRequest, ImportCompetitorFeedResponse, ListDiscountsRequest, ListDiscountsResponse, ListPriceListsRequest, ListPriceListsResponse, ListPromocodesRequest, ListPromocodesResponse, PriceList, Promocode, RecordPOPricesRequest, RecordPOPricesResponse, RefreshCompetitorSummariesRequest, RefreshCompetitorSummariesResponse, RemovePriceListRuleRequest, UpdateDiscountRequest, UpdatePriceListRequest, UpdatePromocodeRequest, ValidatePromocodeRequest, ValidatePromocodeResponse } from "./pricing_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.PricingService
 */
export const PricingService = {
  typeName: "omnios.v1.PricingService",
  methods: {
    /**
     * Price History
     *
     * @generated from rpc omnios.v1.PricingService.GetPriceHistory
     */
    getPriceHistory: {
      name: "GetPriceHistory",
      I: GetPriceHistoryRequest,
      O: GetPriceHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.GetPriceAtDate
     */
    getPriceAtDate: {
      name: "GetPriceAtDate",
      I: GetPriceAtDateRequest,
      O: GetPriceAtDateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * PO Price Tracking
     *
     * @generated from rpc omnios.v1.PricingService.RecordPOPrices
     */
    recordPOPrices: {
      name: "RecordPOPrices",
      I: RecordPOPricesRequest,
      O: RecordPOPricesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.GetProductPOHistory
     */
    getProductPOHistory: {
      name: "GetProductPOHistory",
      I: GetProductPOHistoryRequest,
      O: GetProductPOHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Price Calculator
     *
     * @generated from rpc omnios.v1.PricingService.CalculatePrice
     */
    calculatePrice: {
      name: "CalculatePrice",
      I: CalculatePriceRequest,
      O: CalculatePriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.BulkCalculatePrices
     */
    bulkCalculatePrices: {
      name: "BulkCalculatePrices",
      I: BulkCalculatePricesRequest,
      O: BulkCalculatePricesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Price Intelligence
     *
     * @generated from rpc omnios.v1.PricingService.GetProductPriceSuggestions
     */
    getProductPriceSuggestions: {
      name: "GetProductPriceSuggestions",
      I: GetProductPriceSuggestionsRequest,
      O: GetProductPriceSuggestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.GeneratePriceSuggestions
     */
    generatePriceSuggestions: {
      name: "GeneratePriceSuggestions",
      I: GeneratePriceSuggestionsRequest,
      O: GeneratePriceSuggestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Analytics
     *
     * @generated from rpc omnios.v1.PricingService.GetPriceAnalytics
     */
    getPriceAnalytics: {
      name: "GetPriceAnalytics",
      I: GetPriceAnalyticsRequest,
      O: GetPriceAnalyticsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Price Lists
     *
     * @generated from rpc omnios.v1.PricingService.CreatePriceList
     */
    createPriceList: {
      name: "CreatePriceList",
      I: CreatePriceListRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.UpdatePriceList
     */
    updatePriceList: {
      name: "UpdatePriceList",
      I: UpdatePriceListRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.DeletePriceList
     */
    deletePriceList: {
      name: "DeletePriceList",
      I: DeletePriceListRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.GetPriceList
     */
    getPriceList: {
      name: "GetPriceList",
      I: GetPriceListRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.ListPriceLists
     */
    listPriceLists: {
      name: "ListPriceLists",
      I: ListPriceListsRequest,
      O: ListPriceListsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.AddPriceListRule
     */
    addPriceListRule: {
      name: "AddPriceListRule",
      I: AddPriceListRuleRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.RemovePriceListRule
     */
    removePriceListRule: {
      name: "RemovePriceListRule",
      I: RemovePriceListRuleRequest,
      O: PriceList,
      kind: MethodKind.Unary,
    },
    /**
     * Competitor Prices (competitors are parties with role='competitor')
     *
     * @generated from rpc omnios.v1.PricingService.AddCompetitorPrice
     */
    addCompetitorPrice: {
      name: "AddCompetitorPrice",
      I: AddCompetitorPriceRequest,
      O: AddCompetitorPriceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.GetProductCompetitorPrices
     */
    getProductCompetitorPrices: {
      name: "GetProductCompetitorPrices",
      I: GetProductCompetitorPricesRequest,
      O: GetProductCompetitorPricesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.ImportCompetitorFeed
     */
    importCompetitorFeed: {
      name: "ImportCompetitorFeed",
      I: ImportCompetitorFeedRequest,
      O: ImportCompetitorFeedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PricingService.RefreshCompetitorSummaries
     */
    refreshCompetitorSummaries: {
      name: "RefreshCompetitorSummaries",
      I: RefreshCompetitorSummariesRequest,
      O: RefreshCompetitorSummariesResponse,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service omnios.v1.DiscountService
 */
export const DiscountService = {
  typeName: "omnios.v1.DiscountService",
  methods: {
    /**
     * Discount CRUD
     *
     * @generated from rpc omnios.v1.DiscountService.CreateDiscount
     */
    createDiscount: {
      name: "CreateDiscount",
      I: CreateDiscountRequest,
      O: Discount,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiscountService.UpdateDiscount
     */
    updateDiscount: {
      name: "UpdateDiscount",
      I: UpdateDiscountRequest,
      O: Discount,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiscountService.DeleteDiscount
     */
    deleteDiscount: {
      name: "DeleteDiscount",
      I: DeleteDiscountRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiscountService.GetDiscount
     */
    getDiscount: {
      name: "GetDiscount",
      I: GetDiscountRequest,
      O: Discount,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiscountService.ListDiscounts
     */
    listDiscounts: {
      name: "ListDiscounts",
      I: ListDiscountsRequest,
      O: ListDiscountsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get applicable discounts
     *
     * @generated from rpc omnios.v1.DiscountService.GetProductDiscounts
     */
    getProductDiscounts: {
      name: "GetProductDiscounts",
      I: GetProductDiscountsRequest,
      O: GetProductDiscountsResponse,
      kind: MethodKind.Unary,
    },
  }
};

/**
 * @generated from service omnios.v1.PromocodeService
 */
export const PromocodeService = {
  typeName: "omnios.v1.PromocodeService",
  methods: {
    /**
     * Promocode CRUD
     *
     * @generated from rpc omnios.v1.PromocodeService.CreatePromocode
     */
    createPromocode: {
      name: "CreatePromocode",
      I: CreatePromocodeRequest,
      O: Promocode,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromocodeService.UpdatePromocode
     */
    updatePromocode: {
      name: "UpdatePromocode",
      I: UpdatePromocodeRequest,
      O: Promocode,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromocodeService.DeletePromocode
     */
    deletePromocode: {
      name: "DeletePromocode",
      I: DeletePromocodeRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromocodeService.GetPromocode
     */
    getPromocode: {
      name: "GetPromocode",
      I: GetPromocodeRequest,
      O: Promocode,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromocodeService.ListPromocodes
     */
    listPromocodes: {
      name: "ListPromocodes",
      I: ListPromocodesRequest,
      O: ListPromocodesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Customer assignment
     *
     * @generated from rpc omnios.v1.PromocodeService.AssignPromocode
     */
    assignPromocode: {
      name: "AssignPromocode",
      I: AssignPromocodeRequest,
      O: AssignPromocodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Validation & Application
     *
     * @generated from rpc omnios.v1.PromocodeService.ValidatePromocode
     */
    validatePromocode: {
      name: "ValidatePromocode",
      I: ValidatePromocodeRequest,
      O: ValidatePromocodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PromocodeService.ApplyPromocode
     */
    applyPromocode: {
      name: "ApplyPromocode",
      I: ApplyPromocodeRequest,
      O: ApplyPromocodeResponse,
      kind: MethodKind.Unary,
    },
  }
};

